import * as React from 'react'
import {
  Group as PanelGroup,
  Panel,
  Separator as PanelResizeHandle,
} from 'react-resizable-panels'

import { cn } from '@shared/ui/lib/utils'

const ResizablePanelGroup = PanelGroup
const ResizablePanel = Panel

interface ResizableHandleProps
  extends React.ComponentPropsWithoutRef<typeof PanelResizeHandle> {
  readonly withHandle?: boolean
}

const ResizableHandle = React.forwardRef<HTMLDivElement, ResizableHandleProps>(function ResizableHandle({ className, children, elementRef, withHandle = true, ...props }, ref) {
  return (
    <PanelResizeHandle
      className={cn(
        'relative z-10 flex w-2 shrink-0 cursor-col-resize items-center justify-center bg-transparent outline-none transition-colors hover:bg-[color-mix(in_srgb,var(--lms-color-brand-action)_12%,transparent)] focus-visible:bg-[color-mix(in_srgb,var(--lms-color-brand-action)_12%,transparent)]',
        className,
      )}
      elementRef={elementRef ?? ref}
      {...props}
    >
      {withHandle ? <span className="pointer-events-none h-10 w-1 rounded-full bg-[var(--lms-color-border-strong)]" /> : children}
    </PanelResizeHandle>
  )
})

export { ResizableHandle, ResizablePanel, ResizablePanelGroup }
export type { ResizableHandleProps }
